import type { ComponentProps, CSSProperties } from 'react'
import { cn } from '@/lib/utils'

export type ShimmerProps = ComponentProps<'span'> & {
  duration?: number
}

export const Shimmer = ({
  className,
  duration = 1.5,
  children,
  style,
  ...props
}: ShimmerProps) => (
  <span
    className={cn('animate-skeleton text-muted-foreground', className)}
    style={{ animationDuration: `${duration}s`, ...style } as CSSProperties}
    {...props}>
    {children}
  </span>
)
